var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-card",
    { staticClass: "detail-content" },
    [
      _c("template", { attrs: { slot: "body" }, slot: "body" }, [
        _c("section", { staticClass: "detail-content__row" }, [
          _c("p", { staticClass: "detail-content__row__title" }, [
            _vm._v("Fatura: "),
            _c("span", [_vm._v(_vm._s(_vm.detail.billingName))])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "detail-content__row__title" }, [
            _vm._v("Centro de distribuição: "),
            _c("span", [
              _vm._v(_vm._s(_vm.getWarehouseDescription(_vm.detail)))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail-content__row__values" },
            _vm._l(_vm.valuesFirstRow, function(v, i) {
              return _c("div", { key: i }, [
                _c("p", { staticClass: "detail-content__row__values__label" }, [
                  _vm._v(_vm._s(v.label))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "detail-content__row__values__value" }, [
                  _vm._v(_vm._s(v.value))
                ])
              ])
            })
          )
        ]),
        _vm._v(" "),
        _vm.valuesSecondRow.length
          ? _c("section", { staticClass: "detail-content__row" }, [
              _c(
                "p",
                { staticClass: "detail-content__row__title" },
                [
                  _c("span", [_vm._v("Pedidos com divergências")]),
                  _vm._v(" "),
                  _c(
                    "sc-tag",
                    {
                      attrs: {
                        size: "is-medium",
                        type: "is-danger is-light",
                        rounded: ""
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-info-circle" }),
                      _vm._v(" Fora da margem\n        ")
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-content__row__values" },
                _vm._l(_vm.valuesSecondRow, function(v, i) {
                  return _c("div", { key: i }, [
                    _c(
                      "p",
                      { staticClass: "detail-content__row__values__label" },
                      [
                        _vm._v(_vm._s(v.label) + "\n            "),
                        v.description
                          ? _c(
                              "sc-tooltip",
                              {
                                attrs: {
                                  type: "is-dark",
                                  position: "is-bottom",
                                  label: v.description,
                                  multilined: ""
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "far fa-question-circle"
                                })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    v.hasColor
                      ? _c(
                          "p",
                          {
                            staticClass: "detail-content__row__values__value",
                            class: _vm.getClassByDivergenceType(v.value)
                          },
                          [_vm._v(_vm._s(v.value))]
                        )
                      : _c(
                          "p",
                          { staticClass: "detail-content__row__values__value" },
                          [_vm._v(_vm._s(v.value))]
                        )
                  ])
                })
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.valuesThirdRow.length
          ? _c("section", { staticClass: "detail-content__row" }, [
              _c(
                "p",
                { staticClass: "detail-content__row__title" },
                [
                  _c("span", [_vm._v("Pedidos com divergências")]),
                  _vm._v(" "),
                  _c(
                    "sc-tag",
                    {
                      attrs: {
                        size: "is-medium",
                        type: "is-info is-light",
                        rounded: ""
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-info-circle" }),
                      _vm._v(" Dentro da margem\n        ")
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-content__row__values" },
                _vm._l(_vm.valuesThirdRow, function(v, i) {
                  return _c("div", { key: i }, [
                    _c(
                      "p",
                      { staticClass: "detail-content__row__values__label" },
                      [
                        _vm._v(_vm._s(v.label) + "\n            "),
                        v.description
                          ? _c(
                              "sc-tooltip",
                              {
                                attrs: {
                                  type: "is-dark",
                                  position: "is-bottom",
                                  label: v.description,
                                  multilined: ""
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "far fa-question-circle"
                                })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "detail-content__row__values__value",
                        class: _vm.getClassByDivergenceType(v.value)
                      },
                      [_vm._v(_vm._s(v.value))]
                    )
                  ])
                })
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "detail-content__actions" },
          [
            _c(
              "router-link",
              {
                staticClass: "button no-border",
                attrs: {
                  to: {
                    name: "billing-upload-page",
                    query: { overwrite: _vm.detail.billingId }
                  }
                }
              },
              [_vm._v("\n        Reenviar fatura\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button",
                class: { "is-loading": _vm.isLoadingExtractButton },
                on: {
                  click: function() {
                    return _vm.exportDetail(true)
                  }
                }
              },
              [_vm._v("\n        Exportar pedidos com divergência\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button",
                class: { "is-loading": _vm.isLoadingExtractButton },
                on: {
                  click: function() {
                    return _vm.exportDetail(false)
                  }
                }
              },
              [_vm._v("\n        Exportar todos os pedidos\n      ")]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2298293c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2298293c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/detail/components/single-billing-detail/SingleBillingDetail.vue
// module id = null
// module chunks = 